import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

function RiskAssessmentCard(props) {
  const cardTextColor = props.textColor;
  const [isDesktop] = useCheckScreenSize();
  const useStyles = makeStyles(theme => ({
    sectionTitle: {
      fontFamily: 'MuseoSans-500',
      fontSize: isDesktop ? 30 : 25,
      lineHeight: '30px',
      color: cardTextColor,
      textAlign: isDesktop ? 'left' : 'center',
    },
    riskLevel: {
      fontFamily: 'MuseoSans-900',
      fontSize: 25,
      lineHeight: '30px',
      color: cardTextColor,
      textAlign: isDesktop ? 'left' : 'center',
      textTransform: 'uppercase',
    },
    cta: {
      fontFamily: 'MuseoSans-500',
      fontSize: 25,
      fontWeight: 'normal',
      lineHeight: '30px',
      color: cardTextColor,
      textAlign: isDesktop ? 'left' : 'center',
    },
    percentage: {
      fontSize: isDesktop ? '65px' : '55px',
      color: cardTextColor,
      fontFamily: 'Museo-900',
    },
    description: {
      fontSize: isDesktop ? '16px' : '14px',
      color: '#222222',
      fontFamily: 'Museo-500',
      marginRight: '4px',
    },
    additionalLink: {
      fontSize: '12px',
      color: '#222222',
      fontFamily: 'MuseoSans',
      fontWeight: 300,
      fontStyle: 'italic',
    },
  }));

  const classes = useStyles();
  return (
    <Box
      style={{
        paddingLeft: '20px',
        paddingRight: '20px',
        marginTop: '14px',
        paddingBottom: isDesktop ? '22px' : '0px',
      }}
    >
      {!isDesktop && (
        <>
          <Box
            className={classes.sectionTitle}
            display={'block'}
            textAlign={'center'}
          >
            {props.showOnlyCta !== true && props.sectionTitle}
          </Box>
          <Box className={props.showOnlyCta ? classes.cta : classes.riskLevel}>
            {props.showOnlyCta ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.sectionSubtitle,
                }}
              />
            ) : (
              props.sectionSubtitle
            )}
          </Box>
        </>
      )}

      <Grid container direction="row" justify="flex-start" alignItems="center">
        <Grid item xs={6}>
          {isDesktop && (
            <>
              <Box className={classes.sectionTitle}>
                {props.showOnlyCta !== true && props.sectionTitle}
              </Box>
              <Box
                className={props.showOnlyCta ? classes.cta : classes.riskLevel}
                paddingBottom={isDesktop && 4}
              >
                {props.showOnlyCta ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props.sectionSubtitle,
                    }}
                  />
                ) : (
                  props.sectionSubtitle
                )}
              </Box>
            </>
          )}
          {props.percentage ? (
            <Box className={classes.percentage}>{props.percentage}</Box>
          ) : (
            <Box style={{ height: '20px' }}></Box>
          )}
          <Box className={classes.description}>
            {props.showOnlyCta ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: props.description,
                }}
              />
            ) : (
              props.description
            )}
          </Box>
          <Box
            style={{
              marginTop: '12px',
            }}
          >
            {props.children}
          </Box>
        </Grid>

        <Grid item xs={6}>
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              src={props.image}
              alt="riskImage"
              width={isDesktop ? 260 : 140}
            />
          </Box>
        </Grid>
        <Grid item xs={12} className={classes.additionalLink}>
          {props.additionalLink}
        </Grid>
      </Grid>
      {/* total likelihood covid 19 infection */}
    </Box>
  );
}

RiskAssessmentCard.propTypes = {};

export default RiskAssessmentCard;
